export default __webpack_public_path__ + "static/media/love.a499d221.png";